import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { useRecordContext } from 'react-admin';
const useStyle = makeStyles(theme => ({
    code: {
        fontFamily: 'monospace',
        fontSize: '16px',
        color: '#479ADA',
    },
}));
const CodeField = props => {
    const record = useRecordContext(props);
    const val = record['code'];
    const styles = useStyle();
    return (
        <Typography variant="button" className={styles.code}>
            #{val}
        </Typography>
    );
};

export default CodeField;
